import React from 'react';
import { Target, MessageSquare, ShieldAlert, Eye } from 'lucide-react';

export const DiagnosticAnalysisSection = () => {
  const analyses = [
    {
      icon: Target,
      title: "Votre priorité commerciale",
      description: "Quelles offres et quels clients souhaitez-vous réellement développer ?"
    },
    {
      icon: MessageSquare,
      title: "Votre promesse",
      description: "Que comprend un prospect lorsqu'il découvre votre entreprise ?"
    },
    {
      icon: ShieldAlert,
      title: "Les freins à la décision",
      description: "Qu'est-ce qui peut encore créer du doute ou ralentir la prise de contact ?"
    },
    {
      icon: Eye,
      title: "La clarté de votre message",
      description: "Est-ce que votre entreprise est comprise rapidement et sans effort ?"
    }
  ];

  return (
    <section id="diagnostic" className="py-32 bg-gray-50 relative">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto fade-in-section">
          <h2 className="section-title mb-12 text-center">
            Le diagnostic ne cherche pas à rendre<br />
            votre communication plus jolie.<br />
            Il cherche à la rendre plus <span className="text-accent">juste</span>.
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {analyses.map((analysis, index) => (
              <div 
                key={index}
                className="bg-white p-8 rounded-lg border border-gray-200 hover:border-accent hover:shadow-lg transition-all"
              >
                <div className="w-14 h-14 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <analysis.icon className="h-7 w-7 text-accent" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {analysis.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {analysis.description}
                </p>
              </div>
            ))}
          </div>

          <div className="text-center p-6 bg-white border border-gray-200 rounded-lg">
            <p className="text-gray-700 italic">
              Les éléments étudiés dépendent de la situation de l'entreprise et du périmètre défini au démarrage.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiagnosticAnalysisSection;
